import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserManagementComponent } from './components/index.component';
import { UsersComponent } from './components/users/users.component';
import { RolesComponent } from './components/roles/roles.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { RegisterUserComponent } from '../register-user/register.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserPasswordComponent } from './components/user-password/user-password.component';
import { UserMgmtLoaderComponent } from './components/user-mgmt-loader/user-mgmt-loader.component';
import { AppLoadingModule } from '@eview/core/loading/app-loading.module';

export const routes: Routes = [
  {
    path: '',
    component: UserManagementComponent,
    outlet: 'dashboard'
  }
];

@NgModule({
  imports: [
    SharedModule,
    NgbModule,
    RouterModule.forChild(routes),
    FontAwesomeModule,
    InfiniteScrollModule,
    NgbNavModule,
    AppLoadingModule
  ],
  declarations: [
    UserManagementComponent,
    UsersComponent,
    RolesComponent,
    PermissionsComponent,
    RegisterUserComponent,
    UserMgmtLoaderComponent
  ],
  exports: [
    UserManagementComponent,
    UsersComponent,
    RolesComponent,
    PermissionsComponent,
    UserMgmtLoaderComponent
  ]
})
export class UserManagementModule {}
